import React from "react";
import Tippy from "@tippy.js/react";
import { Form } from "formik";

import Input from "../Input";

import styles from "./ResetPasswordForm.module.scss";
import Checkbox from "../Checkbox";
import i18n from "../../constants/i18n";

const ResetPasswordFormView = ({
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    values,
    updatePassword,
    requiresIlomeConsent,
    requiresTermsAndConditions,
    loadIlomeConsentRequirement,
}) => {
    return (
        <Form>
            {updatePassword ? (
                <Input
                    errors={errors}
                    touched={touched}
                    name="current"
                    label="Huidig wachtwoord"
                    placeholder="Huidig wachtwoord"
                    type="password"
                />
            ) : (
                <Input
                    errors={errors}
                    touched={touched}
                    name="email"
                    label="E-mail"
                    placeholder="E-mail"
                    onBlur={(event) => {
                        handleBlur(event);
                        loadIlomeConsentRequirement(event.target.value);
                    }}
                />
            )}

            <Input
                errors={errors}
                touched={touched}
                name="password"
                label="Nieuw Wachtwoord"
                placeholder="Nieuw Wachtwoord"
                type="password"
            />
            <Input
                errors={errors}
                touched={touched}
                name="passwordConfirmation"
                label="Herhaal wachtwoord"
                placeholder="Herhaal wachtwoord"
                type="password"
            />

            {requiresTermsAndConditions && (
                <>
                    <div className="columns is-centered">
                        <div className={`column is-narrow ${styles.termsLink}`}>
                            <a
                                href={i18n.loginForm.termsAndConditionsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Klik hier voor de algemene voorwaarden
                            </a>
                        </div>
                    </div>

                    <div className="columns is-centered">
                        <div
                            className={`column is-full ${styles.checkboxContainer}`}
                        >
                            <Checkbox
                                errors={errors}
                                touched={touched}
                                name="termsAndConditions"
                                value={values.termsAndConditions}
                                setFieldValue={setFieldValue}
                                handleBlur={handleBlur}
                                label={
                                    i18n.loginForm.termsAndConditionsAgreement
                                }
                                reversed
                                required="required"
                            />
                        </div>
                    </div>
                </>
            )}

            {requiresIlomeConsent && (
                <div className="columns is-centered">
                    <div
                        className={`column is-full ${styles.checkboxContainer}`}
                    >
                        <div className={styles.checkboxWithTooltip}>
                            <Checkbox
                                errors={errors}
                                touched={touched}
                                name="ilomeConsent"
                                value={values.ilomeConsent}
                                setFieldValue={setFieldValue}
                                handleBlur={handleBlur}
                                label={
                                    i18n.resetPasswordForm
                                        .ilomeConsentAgreement
                                }
                                reversed
                                required="required"
                            />
                            <Tippy
                                content={
                                    <>
                                        <p>{i18n.ilomeConsentPage.bodyFirst}</p>
                                        <p>{i18n.ilomeConsentPage.bodySecond}</p>
                                    </>
                                }
                            >
                                <span className={styles.ilomeInfoIcon}>
                                    <i className="fas fa-question" />
                                </span>
                            </Tippy>
                        </div>
                    </div>
                </div>
            )}

            <div className="columns is-centered">
                <div
                    className={`column is-narrow ${styles.submitBtnContainer}`}
                >
                    <button
                        type="submit"
                        className={`button is-primary is-rounded ${
                            styles.submitBtn
                        } ${isSubmitting ? "is-loading" : ""}`}
                        disabled={isSubmitting}
                    >
                        Opslaan
                    </button>
                </div>
            </div>
        </Form>
    );
};

export default ResetPasswordFormView;
